import { LiheContentResponseDTO } from "@requests"
import {ref, Ref} from "vue"

const liheContentResponse: Ref<LiheContentResponseDTO | null> = ref(null)

export default liheContentResponse